<template>
    <div id="verified">
        <!-- 电信实名链接 -->
        <div class="card-dianxin" v-if="supplierTypeCode==1 || supplierTypeCode==5">
            <h1>ICCID: {{ verifiedInfo.iccid }}</h1>
            <h1>
               <button class="tag-read"  :data-clipboard-text="setPay" @click="copy" background-color='black'>复制ICCID号</button>
            </h1>
            <iframe class="dianxin-iframe" src="http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp="></iframe>
        </div>
        
        <!-- 移动实名链接 -->
        <div class="card-yidong" v-else-if="supplierTypeCode==3" >
            <h1>ICCID: {{ verifiedInfo.iccid }}</h1>
            <h1>接入号: {{ verifiedInfo.intoNo }}</h1>
            <iframe class="dianxin-iframe" :src="cuccAuth"></iframe>
        </div>
        
        <!-- 联通实名 -->
        <div class="card-yidong" v-else-if="supplierTypeCode==4 || supplierTypeCode==49">
            <h1 style="color:red">请复制此ICCID前往扫码: {{ verifiedInfo.iccid }}</h1>
            <h1>长按图片，前往联通实名官方小程序进行实名！！</h1>
            <img src="@/assets/liantongAuto.png" width=100%>
        </div>

        <div class="card-other" v-else>
            <h4>尊敬的用户,为了贯彻工信部《电话用户真实身份信息登记规定》,请对您购买的流量卡进行实名认证。</h4>
            <div class="main">
                <form >
                    <div class="line">
                        <label>SIM卡号：</label>                    
                        <div><span>{{ verifiedInfo.iccid }}</span></div>
                    </div>
                    <div class="line">
                        <label>姓名：</label>
                        <div>
                            <input type="text" v-model="verifiedInfo.nickname" :disabled="disabledFlag">
                        </div>                    
                    </div>
                    <div class="line">
                        <label>手机号：</label>
                        <div>
                            <input type="text" v-model="verifiedInfo.phone" :disabled="disabledFlag">
                        </div>                    
                    </div>
                    <div class="line">
                        <label>身份证号：</label>
                        <div>
                            <input type="text" v-model="verifiedInfo.cardCode" :disabled="disabledFlag">
                        </div>                    
                    </div>
                    <div class="title">上传身份证正反面照</div>                
                    <div class="many">                    
                        <div class="uploadOuter">                        
                            <input type="file" ref="file1" @change="showImg($event, 'existFrontImg', 'frontImgUrl')" :disabled="disabledFlag">   
                            <div v-if="!existFrontImg">上传身份证正面</div>
                            <img v-else :src="frontImgUrl" alt="">  
                        </div>
                        <div class="uploadOuter">
                            <input type="file" ref="file2" @change="showImg($event, 'existBackImg', 'backImgUrl')" :disabled="disabledFlag">
                            <div v-if="!existBackImg">上传身份证反面</div>
                            <img v-else :src="backImgUrl" alt="">  
                        </div>
                    </div>
                    <div class="title">上传手持身份证照</div>
                    <div class="many">                    
                        <div class="uploadOuter">
                            <img src="@/assets/shouchi.jpg">                        
                        </div>
                        <div class="uploadOuter">
                            <input type="file" ref="file3" @change="showImg($event, 'existHandImg', 'handImgUrl')" :disabled="disabledFlag">
                            <div v-if="!existHandImg">上传手持身份证</div>
                            <img v-else :src="handImgUrl" alt="">  
                        </div>
                    </div>
                    <div class="btnOuter">
                        <mt-button type="primary" size="large" @click.prevent="sureVerifiedHandler" :disabled="disabledFlag">确定</mt-button>
                    </div>                
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import {wxRequest, verified} from '@/api/user'
import VueClipboard from 'vue-clipboard2'
import Clipboard from 'clipboard';
export default {
    data(){
        return {
            setPay:localStorage.getItem('iccid'),
            recordLoginText:localStorage.getItem('recordLoginText'),
            state: '',
            supplierTypeCode: '',
            verifiedInfo: {
                iccid: localStorage.getItem('iccid'),
                nickname: '',
                phone: '',
                cardCode: '',
                intoNo: localStorage.getItem('intoNo'),
            },
            disabledFlag: false,
            existFrontImg: false,
            existBackImg: false,
            existHandImg: false,
            frontImgUrl: '',
            backImgUrl: '',
            handImgUrl: '',
            cuccAuth:''
        }
    },
    methods: {
        onCopy(){
           window.alert('复制成功')
        },
        copy() {
        var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
                  console.log('复制成功')
                  window.alert("复制成功");
                  clipboard.destroy()// 释放内存
             })
        clipboard.on('error', e => {
               console.log('不支持复制,该浏览器不支持自动复制')
               alert("复制失败")
               clipboard.destroy()// 释放内存
             })
         },
        getVerifiedInfoHandler(){            
            var data = {
                iccid: localStorage.getItem('iccid')
            }
            wxRequest("wxAuth/list", data, "post").then(res => {  
                if(res.data.code == 200 && res.data.data){
                    for(var key in this.verifiedInfo){
                        this.verifiedInfo[key] = res.data.data[key];
                        this.existFrontImg = true;
                        this.existBackImg = true;
                        this.existHandImg = true;
                        this.frontImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.headerUrl
                        this.backImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.backHeaderUrl
                        this.handImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.handheldUrls
                    }
                }
            })
        },
        sureVerifiedHandler(){
            var data =  JSON.parse(JSON.stringify(this.verifiedInfo));
            data.backUrl = this.$refs.file1.files[0];
            data.frontUrl = this.$refs.file2.files[0];
            data.handUrl = this.$refs.file3.files[0];
            data.iccid=localStorage.getItem('iccid');

            if(this.state == 2){
                for(var key in this.verifiedInfo){
                    if(!this.verifiedInfo[key] || !this.frontImgUrl || !this.backImgUrl || !this.handImgUrl){
                        this.$messagebox.alert('请填写完整的认证信息');
                        return false;
                    }
                }
            }else if(this.state == 4){                
                for(var key in data){
                    if(!data[key]){
                        this.$messagebox.alert('请填写完整的认证信息');
                        return false;
                    }
                }                  
            }

            verified(data).then(res => {
                if(res.data.code == 200){
                    this.$router.push('/user/home');
                }else{
                    this.$messagebox.alert(res.data.message);
                }
            })
        },
        showImg(event, showImgkey, imgUrl){
            this.$data[showImgkey] = true;
            const files = event.target.files
            let filename = files[0].name          //只有一个文件
            if ( filename.lastIndexOf('.') <= 0 ) {
                return alert("Please add a valid image!")        //判断图片是否有效
            }
            const fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.addEventListener('load',() => {
                this.$data[imgUrl] = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0]
        }
    },
    created(){
       var state = this.$route.query.state;
       this.state = state;
       if(state == 1 || state == 3){
           this.disabledFlag = true;
       }
       this.cuccAuth="https://ec.iot.10086.cn/service/wx/person/login?openId="+localStorage.getItem('openId')+"&msgId=2";
       console.log(this.cuccAuth)
       this.getVerifiedInfoHandler();
    },

    mounted(){
        this.supplierTypeCode = this.$route.query.supplierTypeCode;
        this.verifiedInfo.iccid = this.$route.query.iccid?this.$route.query.iccid:localStorage.getItem('iccid')
    },

    quitHome() {
        this.$router.push({
          path:"/user/home",
      });
    }

}
</script>
<style lang="less">
#verified {
    height: 100%;
    h4 {
        color: #fff;
        font-size: 10px;
        background: #ff9c3c;
        line-height: 1.5em;
        padding: 6px 3%;
    }
    .main {
        height: calc(100% - 48px);
        padding: 0 4%;
        form{
            height: 100%;
        }
        .line {
            border-bottom: 1px solid #e5e5e5;
        }
        .many {
            display: flex;
            justify-content: space-between;
            label {
                display: block;
                line-height: 36px;
            }
            .uploadOuter {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 48%;
                height: 100px;
                border: 1px dashed #e5e5e5;
                box-sizing: border-box;
                input[type=file] {
                    position: absolute;
                    top: 0;
                    width: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }                
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .title {
            line-height: 28px;
            margin-top: 10px;
        }
        .btnOuter {
            display: flex;
            align-items: center;
            height: calc(100% - 424px;)
        }
    }


    .card-dianxin{
        width: 100%;
        height: 100%;
        h1{
            font-size: 14px;
            background: #fff;
            line-height: 1.5em;
            padding: 6px 3%;
        }
        .dianxin-iframe{
            width: 100%;
            height: 100%;
        }
    }

    .card-yidong{
        width: 100%;
        height: 100%;
        h1{
            font-size: 16px;
            background: #fff;
            line-height: 1.5em;
            padding: 3px 3%;
        }
        .dianxin-iframe{
            width: 100%;
            height: 100%;
        }
    }

    .card-other{
        width: 100%;
        height: 100%;
    }
    
}
</style>
